import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { errMsg, useApi } from "@/lib/api";
import { Button } from "@/components/ui/button";
import AppShell from "@/components/layout/AppShell";
import { DiaryEntry } from "@/components/ops/DiaryEntry";

// MUSORA internal admins only: daily pilot log. Reads platform signals, never contacts clients or sends anything.
export default function PilotDiary() {
  const api = useApi();
  const [items, setItems] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => api.get("/admin/pilot-diary").then(({ data }) => setItems(data.items)).catch((e) => toast.error(errMsg(e))), [api]);
  useEffect(() => { load(); }, [load]);
  const record = async () => { setBusy(true); try { await api.post("/admin/pilot-diary/snapshot"); toast.success("Controlli di oggi registrati"); await load(); } catch (e) { toast.error(errMsg(e)); } setBusy(false); };
  return (
    <AppShell>
      <div className="mx-auto max-w-5xl space-y-5 p-4 sm:p-6" data-testid="diary-page">
        <header className="flex flex-wrap items-end justify-between gap-3">
          <div><h1 className="text-2xl font-semibold text-slate-900">Diario del pilota</h1>
            <p className="text-sm text-slate-600">Un controllo al giorno: avvisi, coda email, gate, riconciliazione e blocchi di sicurezza, con note e decisione. Non contatta i clienti.</p></div>
          <Button onClick={record} disabled={busy} data-testid="diary-record">Registra i controlli di oggi</Button>
        </header>
        {!items ? <p className="text-sm text-slate-500">Caricamento…</p> : !items.length ? <p className="text-sm text-slate-500" data-testid="diary-empty">Nessuna registrazione.</p>
          : items.map((e) => <DiaryEntry key={`${e.id}-${e.snapshot_at}`} e={e} onSaved={load} />)}
      </div>
    </AppShell>
  );
}
